import { FC, useEffect } from "react";

import { useAppDispatch, useAppSelector } from "@/shared/hooks";

import styles from "./UserReviewForm.module.scss";
import { Button } from "@/shared";
import { convertDate } from "@/shared/helpers/ConvertDate";
import { IUser, UserKeysEnum } from "@/entities/users/types";
import { UserRolesEnum } from "@/app/model/types";
import { ResetPasswordButton } from "@/features/resetPasswordButton/ResetPasswordButton";
import { useDrawer } from "@/app/providers/DrawerProvider/useDrawer";
import ArrowRight from "@/shared/assets/rightMiniArrow.svg";
import { fetchBlockHistory } from "@/entities/users/slice";
import BlockHistory from "./blockHistory/BlockHistory";
import LinkedDealers from "./linkedDealers/LinkedDealers";

interface UserReviewFormProps {
  user: IUser;
}

export const UserReviewForm: FC<UserReviewFormProps> = ({ user }) => {
  const dispatch = useAppDispatch();
  const { blockHistories } = useAppSelector((state) => state.users);
  const { closeDrawer, openDrawer } = useDrawer();
  const { roleName } = useAppSelector((state) => state.viewer);

  const tableHeaders = Object.keys(UserKeysEnum) as Array<
    keyof typeof UserKeysEnum
  >;

  const canSeeLinkedDealers =
    (roleName === "Admin" || roleName === "TechAdmin") &&
    user.roleName === "Manager";
  const excludeItems: (keyof IUser)[] = [
    "id",
    "image",
    "dealerId",
    "dealerName",
    "registrationDate",
    "managerDealers",
  ];

  const handleHistoryClick = () => {
    openDrawer(<BlockHistory blockHistory={blockHistories} user={user} />, {
      isBig: true,
    });
  };

  const handleLinkedDealersClick = () => {
    openDrawer(<LinkedDealers />, {
      isBig: true,
      width: 500,
      maxWidth: 500,
    });
  };

  useEffect(() => {
    dispatch(fetchBlockHistory(user.id));
  }, []);

  return (
    <>
      <div className={styles.userInfoList}>
        {tableHeaders.map((userValue: keyof IUser) => {
          if (!excludeItems.includes(userValue)) {
            return (
              <div key={user.id + userValue} className={styles.userRow}>
                <p className={styles.userRowLeft}>{UserKeysEnum[userValue]}</p>
                <p className={styles.userRowRight}>
                  {userValue === "registrationDate" && user[userValue]
                    ? convertDate(user[userValue])
                    : ""}
                  {userValue !== "blockedDate" &&
                    userValue !== "registrationDate" &&
                    userValue !== "roleName" &&
                    userValue !== "managerDealers" &&
                    user[userValue]}
                </p>
                {userValue === "roleName" && (
                  <p className={styles.userRowRight}>
                    {UserRolesEnum[user[userValue]]}
                  </p>
                )}
                {userValue === "blockedDate" && (
                  <p className={styles.userRowRight}>
                    {user.blockedDate ? (
                      <span style={{ color: "#ff4d4f" }}>Заблокирован</span>
                    ) : (
                      "Активный"
                    )}
                  </p>
                )}
              </div>
            );
          }
        })}
        {blockHistories.length > 0 && (
          <div className={styles.userRow}>
            <p className={styles.userRowLeft}>История блокировки</p>
            <p className={styles.userRowRight}>
              <ArrowRight onClick={handleHistoryClick} />
            </p>
          </div>
        )}
        {canSeeLinkedDealers && (
          <div className={styles.userRow}>
            <p className={styles.userRowLeft}>Привязанные дилеры</p>
            <div className={styles.badge}>{`${
              user.managerDealers?.length || 0
            } дилеров`}</div>
            <p className={styles.userRowRight}>
              <ArrowRight onClick={handleLinkedDealersClick} />
            </p>
          </div>
        )}
      </div>
      <div className={styles.buttonBlock}>
        <ResetPasswordButton currentUser={user} roleName={roleName} />
        <Button
          buttontStyle="cancelBtn"
          name="Отменить"
          onClick={closeDrawer}
        />
      </div>
    </>
  );
};
